import classNames from 'classnames'
import { useField } from 'remix-validated-form'
import FormInputWrapper, { BaseInputClasses, FormInputWrapperProps } from './FormInputWrapper'
type FormSelectProps = {
  options?: { label: string; value: any }[]
  labelClassName?: string
  className?: string
  icon?: React.ReactElement
} & FormInputWrapperProps<HTMLSelectElement>

export default function FormSelect({
  name,
  label,
  placeholder,
  labelClassName,
  className,
  options,
  cols,
  disabled,
  icon,
  ...props
}: FormSelectProps) {
  const { error, getInputProps } = useField(name)
  return (
    <FormInputWrapper {...{ name, label, error, cols, className: labelClassName ?? `text-ui-sm` }}>
      <div className="relative">
        {icon && <div className="absolute left-2 top-3 h-full w-6 text-body-sm leading-3">{icon}</div>}
        <select
          {...getInputProps({ ...props, id: name, placeholder: placeholder })}
          defaultValue={props.defaultValue}
          className={classNames(className, BaseInputClasses, icon && `pl-[40px]`, disabled && `bg-trn-100`)}
          disabled={disabled}
        >
          {options &&
            options?.map((option) => (
              <option key={option.label} value={option.value}>
                {option.label}
              </option>
            ))}
        </select>
      </div>
    </FormInputWrapper>
  )
}
